import { UserAvatarFilledAlt } from "@carbon/icons-react";
import React from "react";
import { useUserContext } from "../../utils/contexts/UserProvider";

export const CornerUser: React.FC = () => {
  const { user } = useUserContext();

  return (
    <div className="flex items-center self-baseline gap-5">
      <div className="flex flex-col">
        <p className="text-black leading-[21.6px] font-medium text-lg text-right">
          {user?.first_name} {user?.last_name}
        </p>
        <p className="text-gray-375 text-[16px] leading-[20.16px] text-right">{user?.email}</p>
      </div>
      <div className="flex items-center justify-center bg-white w-[56px] h-[56px] rounded-full shadow-[0px_0px_1px_0px_#0000000A,0px_1px_1px_0px_#00000008,0px_3px_2px_0px_#00000005,0px_5px_2px_0px_#00000003,0px_7px_2px_0px_#00000000]">
        <UserAvatarFilledAlt size={40} className="text-ominimo-400" />
      </div>
    </div>
  );
};
